import { theme as baseTheme } from '@bottlebooks/gatsby-design-system';
import badge from '@bottlebooks/gatsby-design-system/src/components/Badge/badgeVariants';
import button from '../components/Button/buttonVariants';
import colors from './colors';
import sizes from './sizes';
import space from './space';
import zIndices from './zIndices';
/**
 * The theme for the Bottlebooks dashboard.
 * Theme extensions are done here directly.
 * Variants for separate components are imported and added. That way they can be found more easily.
 */
const theme = Object.assign(Object.assign({}, baseTheme), { space,
    colors,
    sizes,
    zIndices,
    button,
    badge });
export default theme;
//# sourceMappingURL=theme.js.map